(function() {
  var isUiBound = false;

  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function trapFocus(modal) {
    var focusables = modal.querySelectorAll(FOCUSABLE);
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    modal._irTrapHandler = function(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    };
    modal.addEventListener('keydown', modal._irTrapHandler);
    first.focus();
  }

  function releaseFocus(modal) {
    if (modal._irTrapHandler) {
      modal.removeEventListener('keydown', modal._irTrapHandler);
      modal._irTrapHandler = null;
    }
  }

  function hasStoredConsent() {
    try { return !!localStorage.getItem('ir_consent'); } catch (e) { return false; }
  }

  function forceBannerMode() {
    return window.location.search.indexOf('ir_test_ca=1') !== -1 && !hasStoredConsent();
  }

  function applyVisibility(bar, modal, fab) {
    var state = window.irBannerState;
    if ((state === 'banner' || forceBannerMode()) && bar) {
      bar.hidden = false;
      if (modal) modal.hidden = true;
      if (fab) fab.hidden = true;
    } else if ((state === 'fab' || hasStoredConsent()) && !forceBannerMode() && fab) {
      if (bar) bar.hidden = true;
      if (modal) modal.hidden = true;
      fab.hidden = false;
    }
  }

  function setupCookieUiBindings() {
    var bar = document.getElementById('ir-cookie-bar');
    var modal = document.getElementById('ir-cookie-modal');
    var fab = document.getElementById('ir-cookie-fab');
    var acceptBtn = document.getElementById('ir-cookie-accept');
    var rejectBtn = document.getElementById('ir-cookie-reject');
    var settingsBtn = document.getElementById('ir-cookie-settings-open');
    var modalClose = document.getElementById('ir-cookie-modal-close');
    var modalReject = document.getElementById('ir-cookie-modal-reject');
    var modalAccept = document.getElementById('ir-cookie-modal-accept');
    var modalSave = document.getElementById('ir-cookie-modal-save');
    var analyticsToggle = document.getElementById('ir-cookie-analytics');
    var marketingToggle = document.getElementById('ir-cookie-marketing');

    if (!bar || !modal || !fab) return;

    var _fabTrigger = null;

    function hydrateSavedPreferences() {
      var state = window.irConsent ? window.irConsent.getState() : null;
      if (state) {
        if (analyticsToggle) analyticsToggle.checked = !!state.analytics;
        if (marketingToggle) marketingToggle.checked = !!state.marketing;
      } else {
        try {
          var raw = localStorage.getItem('ir_consent');
          if (raw) {
            var d = JSON.parse(raw);
            if (analyticsToggle) analyticsToggle.checked = !!d.a;
            if (marketingToggle) marketingToggle.checked = !!d.m;
          }
        } catch (e) {}
      }
    }

    function showEl(el) { if (el) el.hidden = false; }
    function hideEl(el) { if (el) el.hidden = true; }

    function showBar() { showEl(bar); hideEl(modal); hideEl(fab); releaseFocus(modal); }
    function showModal(trigger) {
      _fabTrigger = trigger || null;
      hydrateSavedPreferences();
      hideEl(bar);
      showEl(modal);
      hideEl(fab);
      trapFocus(modal);
    }
    function showFab() {
      hideEl(bar);
      hideEl(modal);
      showEl(fab);
      releaseFocus(modal);
      if (_fabTrigger) { _fabTrigger.focus(); _fabTrigger = null; }
    }

    function acceptAll() {
      if (window.irSetConsent) window.irSetConsent(true, true);
      showFab();
    }
    function rejectAll() {
      if (window.irSetConsent) window.irSetConsent(false, false);
      showFab();
    }
    function savePrefs() {
      var a = analyticsToggle ? analyticsToggle.checked : false;
      var m = marketingToggle ? marketingToggle.checked : false;
      if (window.irSetConsent) window.irSetConsent(a, m);
      showFab();
    }

    if (!isUiBound) {
      if (acceptBtn) acceptBtn.addEventListener('click', acceptAll);
      if (rejectBtn) rejectBtn.addEventListener('click', rejectAll);
      if (settingsBtn) settingsBtn.addEventListener('click', function() { showModal(settingsBtn); });
      if (modalClose) modalClose.addEventListener('click', function() {
        if (hasStoredConsent() && !forceBannerMode()) showFab();
        else showBar();
      });
      if (modalAccept) modalAccept.addEventListener('click', acceptAll);
      if (modalReject) modalReject.addEventListener('click', rejectAll);
      if (modalSave) modalSave.addEventListener('click', savePrefs);
      if (fab) fab.addEventListener('click', function() { showModal(fab); });

      modal.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          if (hasStoredConsent() && !forceBannerMode()) showFab();
          else showBar();
        }
      });

      var expandBtns = document.querySelectorAll('.ir-cookie-cat__expand');
      for (var i = 0; i < expandBtns.length; i++) {
        (function(btn) {
          btn.addEventListener('click', function() {
            var bodyId = btn.getAttribute('aria-controls');
            var body = document.getElementById(bodyId);
            var isExpanded = btn.getAttribute('aria-expanded') === 'true';
            btn.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
            if (body) body.hidden = isExpanded;
          });
        })(expandBtns[i]);
      }
      isUiBound = true;
    }

    applyVisibility(bar, modal, fab);
  }

  document.addEventListener('irConsentReady', function() {
    setupCookieUiBindings();
  });

  if (document.readyState !== 'loading') setupCookieUiBindings();
  else document.addEventListener('DOMContentLoaded', setupCookieUiBindings);
})();
